var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "handball.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 4.3994184,
    inkscapeCx: 23.75314,
    inkscapeCy: 81.94265,
    "inkscapWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14.077483,9.1172756 0.01235,-0.0254 c 0.0374,-0.074789 0.07796,-0.1499306 0.119945,-0.2250722 C 13.9907,8.6597228 13.668261,8.5757617 13.361344,8.675245 L 11.142372,9.3963228 9.3936519,6.0177698 C 9.1777519,5.6004337 8.6637547,5.4370976 8.2464185,5.6533503 7.8283768,5.8692504 7.6653935,6.3828948 7.8816463,6.8005838 l 2.0806834,4.0199032 c 0.1495783,0.288925 0.4455583,0.460375 0.7563553,0.460375 0.08749,0 0.176037,-0.01376 0.263173,-0.04198 l 2.501547,-0.813153 C 13.68343,9.9738196 13.884514,9.5360223 14.077483,9.1172751",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.345434,11.743354 21.834009,9.74522 c 0.166511,0.643114 0.06773,1.337028 -0.281164,1.95192 l 1.18745,0.944739 -1.463322,2.859264 c -0.214137,0.418394 -0.04798,0.931333 0.370063,1.145822 0.124531,0.06315 0.256823,0.09349 0.387703,0.09349 0.309386,0 0.607836,-0.169333 0.75812,-0.463903 l 1.780469,-3.479447 c 0.184856,-0.360539 0.08925,-0.801511 -0.227894,-1.053748",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.490085,18.950957 -2.6130248,3.426178 c -0.3802945,0.498475 -0.2846917,1.210733 0.2137833,1.591027 0.2053167,0.156634 0.447675,0.232481 0.6875639,0.232481 0.3418417,0 0.6798029,-0.153811 0.903464,-0.446617 L 13.216705,19.12029 c 0.04128,-0.05433 0.07585,-0.111125 0.105834,-0.169333 h -2.832454",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.621467,18.950957 -2.776715,4.309886 -4.0068502,5.945717 c -0.3499556,0.519642 -0.2130778,1.225197 0.3072695,1.575153 0.1943806,0.131586 0.4148667,0.194028 0.6332361,0.194028 0.3647723,0 0.7231945,-0.175331 0.9422695,-0.500592 L 13.73423,24.519554 c 0.0035,-0.0063 0.0085,-0.01305 0.0127,-0.0194 l 3.575051,-5.549194 h -2.700514",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.234822,3.1980169 c 0,1.2015611 -0.983897,2.1762862 -2.197453,2.1762862 -1.213556,0 -2.1978059,-0.9747251 -2.1978059,-2.1762862 0,-1.201914 0.9842499,-2.1762863 2.1978059,-2.1762863 1.213556,0 2.197453,0.9743723 2.197453,2.1762863",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.037311,8.9013756 c -0.09807,-0.030339 -0.19438,-0.060325 -0.290689,-0.090664 -0.233538,0.1393472 -0.488597,0.2462389 -0.763058,0.3125611 -0.210961,0.050447 -0.427214,0.0762 -0.643819,0.0762 -0.91052,0 -1.748014,-0.4363861 -2.326217,-1.1472334 -0.424392,0.2786945 -0.845961,0.7891639 -1.162756,1.4213417 -1.091494,2.3696089 -2.236964,4.9311279 -2.165703,7.2922699 0.0014,0.03881 0.0074,0.07761 0.01658,0.116064 h 4.041775 c 1.191332,-1.788231 2.93864,-3.694995 4.037896,-5.549195 0.634294,-1.042105 0.114652,-2.1695833 -0.744009,-2.4313444",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.289195,5.4526198 c 0.31115,1.2954001 -0.36195,2.5678696 -1.505303,2.8430363 -1.142295,0.2751667 -2.321631,-0.5517445 -2.633486,-1.8471446 -0.311503,-1.2954001 0.362302,-2.5678696 1.505302,-2.8430363 1.142648,-0.2748139 2.321631,0.5517445 2.633487,1.8471446",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandball);
export default __webpack_public_path__ + "static/media/handball.288b5bc67c6edc88c3eb5f7f23c84f42.svg";
export { ForwardRef as ReactComponent };